import React from 'react'

export default () => (
  <footer className="footer">
    © {new Date().getFullYear()} Léo De Spiegeleer. Tous droits réservés.
  </footer>
)
